import { editCell } from '@mummssoftware/utils/constants';
import { getFormDisplayName } from '@mummssoftware/utils/utils';
import {
  EditCellRenderer,
  CreatedByCell,
  NoteCountCellRenderer,
} from './CellRenderer';

// Custom value getter to display form name with supplemental title when present
const formDisplayNameValueGetter = ({ data }: { data?: mumms.GenericForm }) => {
  if (!data) {
    return '';
  }
  return getFormDisplayName({
    displayname: data.displayname || data.formname || '',
    supplementaltitle: data.supplementaltitle,
  });
};

export const smallColumnTableDefs = [
  {
    headerName: '',
    field: 'note-count',
    cellClass: 'no-border no-pad',
    suppressMenu: true,
    cellRendererFramework: NoteCountCellRenderer,
    width: 33,
  },
  {
    headerName: 'Form',
    field: 'formname',
    cellClass: 'no-border',
    suppressMenu: true,
    valueGetter: formDisplayNameValueGetter,
  },
  {
    headerName: 'Visit Date',
    field: 'create-date',
    valueGetter: ({ data }: any) => data.visitdate || '',
    cellClass: 'no-border',
    sortable: true,
    filter: true,
    width: 115,
  },
  {
    headerName: 'Last Edited',
    field: 'update-date',
    valueGetter: ({ data }: any) =>
      data.modifieddate || data.visitdate || data.createdate,
    cellClass: 'no-border',
    sortable: true,
    filter: true,
    width: 115,
  },
];
export const expandedColumnTableDefs = [
  ...smallColumnTableDefs,
  {
    headerName: 'Created By',
    field: 'createpersonfirstname',
    cellClass: 'no-border',
    sortable: true,
    filter: true,
    cellRendererFramework: CreatedByCell,
    width: 160,
  },
  {
    headerName: '',
    field: editCell,
    cellClass: 'no-border no-pad',
    suppressMenu: true,
    cellRendererFramework: EditCellRenderer,
    width: 33,
  },
];
